import styles from './styles.module.scss';
import { getFirstLetter } from '../../utils/ui';

const Avatar = ({ imgUrl, alt = '', size }) => {
  return (
    <div className={`${styles.avatar} ${size === 'small' ? styles.avatarSmall : ''} ${imgUrl ? styles.avatarNoBg : ''}`}>
      {imgUrl ? <img src={imgUrl} alt={alt} /> : getFirstLetter(alt)}
    </div>
  );
};

export default Avatar;
